module.exports = __webpack_public_path__ + "static/media/logo-space.02c4f321.svg";